

import React from 'react';

import styled from 'styled-components';
import { Icon } from '../../../../ui-kit';









const StyledIcon = styled(Icon)`
  justify-content: unset;
`;

const ImageBase = styled.img.attrs((props) => ({
  style: { ...props.style }
}))`${(props) => props.computedStyle}`;

const Image = (props) => {
  const { image, style, computedStyle } = props;
  const { source = '', alt = '', imageLink = '' } = image;

  const imageProps = { src: source, alt, style, computedStyle };

  if (!source) {
    return (
      <StyledIcon
        name="image"
        color="black25"
        size={30} />);


  }

  if (imageLink) {
    return (
      <a target="_blank" rel="noreferrer" href={imageLink}>
        <ImageBase {...imageProps} />
      </a>);

  }

  return (
    <ImageBase {...imageProps} />);

};

export default Image;